<script>
import { STDIZER_URL } from '@/main'

export default {
  data: () => ({
    search: null,
    items: [],
    visibleDelete: false,
    visibleEdit: false,
    visibleCopy: false,
    editingItem: null,
    selected: [],
    maxKey: null,
  }),

  computed: {
    STDIZER_URL() {
      return STDIZER_URL
    },
  },

  methods: {
    editItem(item) {
      this.editingItem = item
      this.visibleEdit = true
    },
    confirmCopyItem(item) {
      this.editingItem = item
      this.visibleCopy = true
    },
    resetEditingItem() {
      this.editingItem = null
    },
    itemUpdated(val) {
      let item
      if (val.key == null) {
        item = Object.assign({ key: this.maxKey }, val)
        this.items.push(item)
      } else {
        item = this.items.find((i) => i.key === val.key)
        item = Object.assign(item, val)
        item.key = this.maxKey
      }
      this.maxKey++
      this.updateDatabase(item)
    },
    deleteItems(items) {
      this.selected = items
      this.visibleDelete = true
    },
    onFileUploaded() {
      this.$router.go(0)
    },
  },

  mounted() {
    this.getData()
  },
}
</script>
